import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { Observable } from 'rxjs/internal/Observable'
import { environment } from '../../../environments/environment'
import { AlertService } from '../../_services/index'
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  options: any
  encryptedData: any
  constructor(private http: HttpClient, private router: Router,
    private alertService: AlertService,) {
    this.encryptedData = localStorage.getItem('adminInfo')
    if (this.encryptedData) {
      const user: any = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      const headers: any = new HttpHeaders({
        Authorization: user.tokenType + ' ' + user.accessToken,
      })
      this.options = { headers }
    }
  }

  updateToken(): void {
    this.encryptedData = localStorage.getItem('adminInfo')
    if (this.encryptedData) {
      const user: any = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      const headers: any = new HttpHeaders({
        Authorization: user.tokenType + ' ' + user.accessToken,
      })
      this.options = { headers }
    }
  }
  dashboard(userType: any): Observable<any> {
    const d = new Date();
    let diff = d.getTimezoneOffset();
    this.updateToken()
    if (userType === 'brand') {
      return this.http.get(
        environment.apiUrl + 'brand/dashboard/',
        this.options
      )
    } else {
      return this.http.get(
        environment.apiUrl + 'admin/v2/dashboard/?time_diff='+diff,
        this.options
      )
    }

  }

  log_out(status: any): void {
    if (status === 403 || status === 401) {
      const headers: any = new HttpHeaders({
        Authorization: '',
      })
      this.options = { headers }
      localStorage.removeItem('adminInfo');
      if (status === 401) {
        this.alertService.error('Somtehing went wrong please login again.')

      }
      this.router.navigate(['/'])
      this.options = '';
    }
  }
}
